import apiClient from "../axiosClient";
import DocumentTemplate from "../interfaces/documentTemplate";
import { TcnTemplate, TemplateUserMapping } from "../interfaces/tcnTemplate";

// Helper: convert Blob/string/object to parsed JSON (or fallback text)
const parseBody = async (raw: any) => {
  try {
    if (!raw) return null;
    if (typeof raw.text === "function") {
      const t = await raw.text();
      try {
        return JSON.parse(t);
      } catch {
        return { message: t };
      }
    }
    if (typeof raw === "string") {
      try {
        return JSON.parse(raw);
      } catch {
        return { message: raw };
      }
    }
    return raw;
  } catch {
    return { message: "Unable to parse response body" };
  }
};

export const isValidDocx = (file: File | null) => {
  if (!file) return false;
  const lower = file.name.toLowerCase();
  return lower.endsWith(".docx");
};

export const uploadDocumentTemplateApi = async (templateName: string, file: File, templateType: string) => {
  const formData = new FormData();
  formData.append("name", templateName);
  formData.append("file", file);
  formData.append("template_type", templateType);

  const response = await apiClient.post("/api/v1/document_template/upload", formData, {
    responseType: "blob",
    validateStatus: () => true,
  });

  const parsed = await parseBody(response.data);
  return { response, parsed };
};

export const fetchDocumentTemplatesApi = async (): Promise<DocumentTemplate[]> => {
  const response = await apiClient.get("/api/v1/document_template");
  if (response.status === 200) {
    return response.data;
  }
  throw new Error("Failed to fetch document templates");
};

export const fetchTcnTemplatesApi = async (): Promise<TcnTemplate[]> => {
  const response = await apiClient.get("/api/v1/tcn_config/tcn_template");
  if (response.status === 200) {
    return response.data || [];
  }
  throw new Error("Failed to fetch TCN templates");
};

export const fetchTemplateUsersApi = async (templateName: string): Promise<TemplateUserMapping[]> => {
  const response = await apiClient.get(
    `/api/v1/tcn_config/tcn_template/${templateName}/users?is_active=true`
  );
  if (response.status === 200) {
    return response.data?.users || [];
  }
  throw new Error("Failed to fetch template users");
};

export const updateMappingApi = async (mapping: TemplateUserMapping, newUsername: string) => {
  // Step 1: Deactivate the old mapping (only if there's an existing user)
  if (mapping.ce_username && mapping.mapping_id) {
    await apiClient.delete(
    `/api/v1/tcn_config/collectedge_tcn_agent_mapping/${mapping.mapping_id}`
  );
  }

  // Step 2: Create new mapping with the new user
  return apiClient.post(`/api/v1/tcn_config/collectedge_tcn_agent_mapping`, {
    username: newUsername,
    tcn_agent_id: mapping.tcn_agent_id,
  });
};

export const deleteMappingApi = async (mappingId: string) => {
  const response = await apiClient.delete(
    `/api/v1/tcn_config/collectedge_tcn_agent_mapping/${mappingId}`
  );
  return response;
};


